import { render, staticRenderFns } from "./reports-detail.vue?vue&type=template&id=21c60fb6&scoped=true"
import script from "./reports-detail.vue?vue&type=script&lang=js"
export * from "./reports-detail.vue?vue&type=script&lang=js"
import style0 from "./reports-detail.vue?vue&type=style&index=0&id=21c60fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c60fb6",
  null
  
)

export default component.exports